import { createContext, ReactNode } from 'react';
import {
  NewItemDefaults,
  ParentRecord,
} from 'components/MenuManagement/MenuItemActions/types/newDrawerTypes';
import type { StagedImageFile } from 'components/MenuManagement/MenuEdit/Fields';

export interface AddNewDrawerContextType {
  newItemDefaults: NewItemDefaults;
  parentRecord: ParentRecord;
  setNewItemPrice: (price: number | null) => void;
  setUploadImageFile: (file: StagedImageFile | null) => void;
  setDefaultModifierChecked: (checked: boolean) => void;
  setIndividualMinimum: (value: number) => void;
  setIndividualMaximum: (value: number) => void;
  isUploading: boolean;
  opened: boolean;
}

export interface AddNewDrawerContextProviderProps extends AddNewDrawerContextType {
  children: ReactNode;
}

export const AddNewDrawerContext = createContext<AddNewDrawerContextType>({
  newItemDefaults: {
    parentUuid: '',
    companyId: 0,
    merchantId: 0,
    itemType: '',
    enabled: false,
    imageUrl: '',
  },
  parentRecord: {
    key: '',
    parents: [],
    children: [],
    seqId: 0,
    uuid: '',
    parentUuid: '',
    itemType: '',
    ordinal: 0,
    enabled: false,
    isDefault: false,
    companyId: 0,
    merchantId: 0,
    externalId: '',
    name: '',
    imageUrl: '',
    description: '',
    isDeleted: false,
    internalName: '',
    numberOfChildren: 0,
    parentMenus: [],
    hasReadOnlyMenu: false,
    parentType: '',
    isMenuPosSourced: false,
  },
  setNewItemPrice: () => {},
  setUploadImageFile: () => {},
  setDefaultModifierChecked: () => {},
  setIndividualMinimum: () => {},
  setIndividualMaximum: () => {},
  isUploading: false,
  opened: false,
});

export function AddNewDrawerContextProvider({
  children,
  ...props
}: AddNewDrawerContextProviderProps) {
  return <AddNewDrawerContext.Provider value={props}>{children}</AddNewDrawerContext.Provider>;
}
